import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src2103436129/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
